import { render, staticRenderFns } from "./ButtonWithTooltip.vue?vue&type=template&id=85a6f3b4&"
import script from "./ButtonWithTooltip.vue?vue&type=script&lang=ts&"
export * from "./ButtonWithTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports